import { Chip as MuiChip, type ChipProps as MuiChipProps } from "@mui/material";
import type React from "react";

export type FeroChipVariant =
  | "pending"
  | "success"
  | "info"
  | "warning"
  | "error";

const variantStyles: Record<
  FeroChipVariant,
  { color: string; backgroundColor: string }
> = {
  pending: {
    color: "#565559",
    backgroundColor: "#E8E6F2",
  },
  success: {
    color: "#FFFFFF",
    backgroundColor: "#4B6F1D",
  },
  info: {
    color: "#445475",
    backgroundColor: "#CAD7EF",
  },
  warning: {
    color: "#AD4E0B",
    backgroundColor: "#FFDDC4",
  },
  error: {
    color: "#793A3A",
    backgroundColor: "#FBD9D9",
  },
};

export interface ChipProps extends Omit<MuiChipProps, "sx" | "variant"> {
  label: string;
  variant: FeroChipVariant;
}

/**
 * A wrapper component for Ferovinum "Status" Chips, this is to encapsulate the designs found here
 * https://www.figma.com/design/R5R3Ue46X0x6U0MbC80qdD/Platform-Designs?node-id=10234-46498&t=zZJS1LcHZRCXwR10-4
 */
export const Chip: React.FC<ChipProps> = ({ label, variant, ...props }) => {
  const styles = variantStyles[variant];

  return (
    <MuiChip
      label={label}
      size="small"
      sx={{
        color: styles.color,
        backgroundColor: styles.backgroundColor,
        borderRadius: "16px",
        "& .MuiChip-label": {
          px: 1.5,
        },
      }}
      {...props}
    />
  );
};
